import type { ShowImage as ShowImageOp } from '~/app/_types/chat-script';
import { Image, ImageProps } from '@styled-system/jsx';

type Props = {
  op: ShowImageOp;
} & ImageProps;

export const ShowImage = ({ op, ...imageProps }: Props) => {
  const { image } = op;

  return (
    <Image
      {...imageProps}
      alt=""
      src={image.imageUrl}
      display="block"
      margin="auto"
      borderRadius="12px"
      maxW="80%"
    />
  );
};
